export default function Monogram({ className = "w-9 h-9 text-gold" }) {
  return (
    <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
      <rect x="2" y="2" width="44" height="44" rx="9" stroke="currentColor" strokeWidth="2.5" />
      <path
        d="M13 33V15l11 12 11-12v18"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
